import React from "react";

export default function Mediaurl() {
  return <div>Mediaurl</div>;
}
